import React, { useRef, useState } from "react";
import ConfirmPopup from "../../../ConfirmPopup/ConfirmPopup";
import AlertMessage from "../../../AlertMessage/AlertMessage";
import { UpdateInvoiceStageAndArchiveStatusService } from "../../../../Services/InvoiceService/InvoiceService";

interface ArchiveButtonProps {
  invoiceId: number | null;
  onSuccess: () => void;
  onBeforeAction: (action: () => void) => void;
}

const ArchiveButton: React.FC<ArchiveButtonProps> = ({
  invoiceId,
  onSuccess,
  onBeforeAction,
}) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submissionInProgress = useRef(false);

  const submitArchive = async () => {
    if (submissionInProgress.current) return;
    if (invoiceId === null) {
      AlertMessage({
        type: "error",
        text: "Something went wrong. The file could not be archived. Please try again.",
      });
      return;
    }

    submissionInProgress.current = true;
    setIsSubmitting(true);
    try {
      const result = await UpdateInvoiceStageAndArchiveStatusService({
        invoiceIds: [invoiceId],
        stageId: null,
        archiveStatus: "Archived",
      });
      if (!result.success) {
        throw new Error(result.message);
      }
      AlertMessage({ type: "success", text: "Supplier statement archived." });
      setOpen(false);
      onSuccess();
    } catch (error) {
      console.error("Failed to archive supplier statement:", error);
      AlertMessage({
        type: "error",
        text: "Something went wrong. The file could not be archived. Please try again.",
      });
    } finally {
      submissionInProgress.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="sv-action-btn sv-btn-archive"
        onClick={() => onBeforeAction(() => setOpen(true))}
      >
        <span className="sv-btn-text">Archive</span>
      </button>

      <ConfirmPopup
        blur
        isOpen={open}
        title="Archive Statement"
       message="Are you sure you want to archive this file?"
        confirmLabel={isSubmitting ? "Processing..." : "Archive"}
        cancelLabel="Cancel"
        confirmColor="var(--color-brand)"
        onConfirm={() => void submitArchive()}
        onCancel={() => setOpen(false)}
        confirmDisabled={isSubmitting}
      />
    </>
  );
};

export default ArchiveButton;
